export default __webpack_public_path__ + "static/media/Ampersand.47533e9e.svg";